/* Handley S&G — Ron's 9-Oct mobile audit UX (Shopify liquid port). Hand-authored (NOT generated
   by port-planner.py). Two jobs:
   1. "Request a callback": one short form (name, phone required; town optional), in a slide-up panel
      from every [data-wc-callback] link and once inline. Posts STRAIGHT to the S&G inbound webhook
      (same URL as the quote — the .sg-app[data-lead-webhook] set on the section), submission_type
      "callback". CORS-blind: tries a readable POST, falls back to no-cors. No webhook set = demo.
   2. The pinned bar shows the visitor's picks + one "Continue". The engine decides where Continue
      goes; only the words change.
   NOTE: no "$750 back" offer — that is Knowles' rebate, not Handley's (truth-gate). */
(function () {
  var app = document.querySelector('.sg-app');
  var WEBHOOK = (app && (app.dataset.leadWebhook || '').trim()) || '';
  var THANKYOU = (app && (app.dataset.thankYou || '').trim()) || '';
  var dlg = document.getElementById('wcCallback');

  function ref(seed) {
    var h = 0, s = String(seed || '') + Date.now();
    for (var i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
    return 'HL-' + h.toString(36).toUpperCase().slice(0, 6);
  }
  function push(ev) { (window.dataLayer = window.dataLayer || []).push(ev); }

  // Same delivery as sg-api-shim.js: a readable POST, then a no-cors retry if CORS blocks it.
  function deliver(payload) {
    var body = JSON.stringify(payload);
    return fetch(WEBHOOK, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body })
      .then(function (r) { if (!r.ok) throw new Error('webhook ' + r.status); return true; })
      .catch(function (e) {
        if (e && /webhook \d+/.test(e.message)) throw e;
        return fetch(WEBHOOK, { method: 'POST', mode: 'no-cors', headers: { 'Content-Type': 'text/plain' }, body: body }).then(function () { return true; });
      });
  }

  // ---- 1. callback panel + forms
  function openPanel(e) {
    if (!dlg || typeof dlg.showModal !== 'function') return; // no <dialog>: the link jumps to the inline form
    e.preventDefault();
    dlg.showModal();
    var first = dlg.querySelector('input[name="name"]');
    if (first) first.focus();
    push({ event: 'sg_callback_opened' });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-wc-callback]');
    if (t) openPanel(e);
  });
  if (dlg) {
    var close = dlg.querySelector('.wc-sheet-close');
    if (close) close.addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
  }

  document.querySelectorAll('form.wc-cb-form').forEach(function (form) {
    var msg = form.querySelector('.wc-cb-msg');
    var btn = form.querySelector('button[type="submit"]');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var d = new FormData(form);
      if (String(d.get('company') || '').trim()) return; // honeypot
      var name = String(d.get('name') || '').trim();
      var phone = String(d.get('phone') || '').trim();
      var town = String(d.get('town') || '').trim();
      var bad = null;
      if (!name) bad = form.querySelector('input[name="name"]');
      else if (phone.replace(/\D/g, '').length < 10) bad = form.querySelector('input[name="phone"]');
      form.querySelectorAll('input').forEach(function (i) { i.removeAttribute('aria-invalid'); });
      if (bad) {
        bad.setAttribute('aria-invalid', 'true');
        msg.textContent = bad.name === 'name' ? 'Please add your name.' : 'Please add a phone number we can call, area code first.';
        bad.focus();
        return;
      }
      if (!WEBHOOK) { msg.textContent = 'Preview: nothing was sent. On the live page this goes straight to our team.'; return; }
      var reference = ref(phone);
      var payload = {
        // firstName carries the FULL name: the WC3 Create Contact maps only firstName, so a split
        // name dropped the surname (Knowles live test, 10 Oct).
        name: name, firstName: name, lastName: '', phone: phone, town: town,
        source: 'S&G Modeler', submission_type: 'callback', reference: reference,
        build_summary: 'Callback request' + (town ? ' from ' + town : '') + '. Wants a call about a shop or garage.',
        summary: 'Callback request' + (town ? ' from ' + town : '') + '. Wants a call about a shop or garage.',
        notes: '', page: location.origin + location.pathname, submitted_at: new Date().toISOString()
      };
      btn.disabled = true; msg.textContent = 'Sending…';
      deliver(payload).then(function () {
        push({ event: 'sg_callback_submitted' });
        if (THANKYOU) { location.assign(THANKYOU + (THANKYOU.indexOf('?') < 0 ? '?' : '&') + 'ref=' + encodeURIComponent(reference) + '&form=callback'); return; }
        msg.textContent = 'Thanks — we’ve got it. Someone from the yard will call you shortly. Reference ' + reference + '.';
        form.querySelectorAll('input').forEach(function (i) { i.disabled = true; });
      }).catch(function () {
        btn.disabled = false;
        msg.textContent = 'That did not go through. Please call us: (705) 887-3242.';
      });
    });
  });

  // ---- 2. the pinned bar: the picks, and one "Continue" (no offer: Handley has none)
  var bar = document.getElementById('stickyCta');
  if (!bar) return;
  var link = bar.querySelector('a.btn');
  // season.js sets the bar's <p> with textContent on load, which wipes these spans; rebuild them.
  function parts() {
    var p = bar.querySelector('p');
    if (!p) return null;
    var picks = p.querySelector('.wc-picks');
    if (picks) return picks;
    var step = p.querySelector('.sc-step');
    p.textContent = '';
    if (step) p.appendChild(step);
    picks = document.createElement('span');
    picks.className = 'wc-picks';
    p.appendChild(picks);
    return picks;
  }
  function sizeText() {
    var p = new URLSearchParams(location.search).get('p');
    var m = p && /^(\d+)x(\d+)$/.exec(p);
    return m ? m[1] + '′ × ' + m[2] + '′' : '';
  }
  function update() {
    var picks = parts();
    if (picks) {
      var chosen = [].map.call(document.querySelectorAll('#presetChips [aria-pressed="true"]'), function (b) {
        return b.textContent.replace(/\s+/g, ' ').trim();
      });
      var s = sizeText();
      var txt = chosen.length > 2 ? chosen.slice(0, 2).join(' + ') + ' + ' + (chosen.length - 2) + ' more' : chosen.join(' + ');
      txt = [txt, s].filter(Boolean).join(' · ') || 'Your garage';
      if (picks.textContent !== txt) picks.textContent = txt;
    }
    // the engine rewrites the button's first text node to its next step; keep the words to one.
    // The engine parks its LAST step at #rangeCard, ~1000px short of the real "Send My Project"
    // submit (#submitBtn), so the pinned CTA dead-ended on mobile (Zak, 15 Oct). At that terminal
    // state repoint the button at the real submit and relabel it, so a phone visitor can finish.
    if (link) {
      var submit = document.getElementById('submitBtn');
      var eng = link.getAttribute('href');
      if (submit && eng === '#rangeCard') { link.setAttribute('href', '#submitBtn'); bar.dataset.term = '1'; }
      else if (eng !== '#submitBtn') { bar.dataset.term = ''; }
      var node = [].find.call(link.childNodes, function (n) { return n.nodeType === 3 && n.nodeValue.trim(); });
      if (bar.dataset.term === '1') { if (node && node.nodeValue.trim() !== 'Send my project') node.nodeValue = 'Send my project '; }
      else { if (node && node.nodeValue.trim() !== 'Continue') node.nodeValue = 'Continue '; }
    }
  }
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; update(); });
  }).observe(document.body, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['aria-pressed', 'href'] });
  window.addEventListener('popstate', update);
  update();
})();
